import { MsalProvider } from "@azure/msal-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ToastContainer } from "react-toastify";
import { Router } from "./Router";
import AuthProvider from "./pages/user/authProvider";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: "always",
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    },
  },
});

const QueryWrapper = ({ children }: any) => (
  <QueryClientProvider client={queryClient}>
    {children}
    <ReactQueryDevtools initialIsOpen={true} />
  </QueryClientProvider>
);

export const App = ({ instance }) => {
  const activeAccount = instance.getActiveAccount();

  return (
    <>
      <MsalProvider instance={instance}>
        <AuthProvider>
          {/*  <AuthProvider> */}
          <ToastContainer
            position="bottom-right"
            autoClose={4000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />

          <QueryWrapper>
            <Router />
          </QueryWrapper>

          {/* </AuthProvider> */}
        </AuthProvider>
      </MsalProvider>
    </>
  );
};
